import { createTheme } from '@mui/material/styles';

export const fspTheme = createTheme({
  palette: {
    primary: {
      main: '#003057',
      light: '#f5f7f9',
      dark: '#003057',
    },
    secondary: {
      main: '#003057',
      light: '#ffffff',
    },
    background: {
      default: '#f5f7f9',
      paper: '#ffffff',
    },
    star: {
      empty: '#D1D5DB',
      filled: '#e6d130',
    },
    text: {
      primary: '#000000',
      secondary: '#003057',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      selected: '#003057',
      disabled: '#9e9e9e',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#003057',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#003057',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#003057',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#003057',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: '#FFFEF7', //for arrow in button
      fspLinks: '#b34900',
      priceQuoteBackground: '#f0f9ee',
      ndrpSectionBackground: '#f9fafa',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#b34900',
          '&:hover': {
            backgroundColor: '#b34900',
          },
          color: 'rgb(255 255 255/1)',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#003057',
          fontWeight: 500,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#003057',
          '&:hover': {
            color: '#003057',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
